module.exports = __webpack_public_path__ + "97b09bbb047cf23d8399aeab6435ede3.fbx";